export const SCHEMA_SUMMARY = [
  {
    table_id: 'ced_output_summary',
    col_id: 'casing_id',
    col_name: 'Casing ID',
    col_desc: 'Casing ID',
    col_unit: '-',
    ui_editable: false,
    ui_show: false,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'ced_output_summary',
    col_id: 'cement_id',
    col_name: 'Cement ID',
    col_desc: 'Cement ID',
    col_unit: '-',
    ui_editable: false,
    ui_show: false,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'ced_output_summary',
    col_id: 'name',
    col_name: 'Name',
    col_desc: 'Name',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'ced_output_summary',
    col_id: 'stage',
    col_name: 'Stage',
    col_desc: 'Stage',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'int',
    decimal: 0
  },
  {
    table_id: 'ced_output_summary',
    col_id: 't',
    col_name: 'Time',
    col_desc: 'Time',
    col_unit: 'min',
    ui_editable: false,
    ui_show: true,
    data_type: 'int',
    decimal: 0
  },
  {
    table_id: 'ced_output_summary',
    col_id: 'md',
    col_name: 'MD',
    col_desc: 'Measured Depth',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_summary',
    col_id: 'z',
    col_name: 'TVD',
    col_desc: 'True Vertical Depth',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_summary',
    col_id: 'fluid_type_tub',
    col_name: 'Tubing Fluid',
    col_desc: 'Type of Fluid inside Tubing',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'ced_output_summary',
    col_id: 'fluid_type_ann',
    col_name: 'Annulus Fluid',
    col_desc: 'Type of Fluid inside Annulus',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'ced_output_summary',
    col_id: 'p_tub',
    col_name: 'Tubing Pressure',
    col_desc: 'Pressure inside Tubing',
    col_unit: 'psi',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_summary',
    col_id: 'p_ann',
    col_name: 'Annulus Pressure',
    col_desc: 'Pressure inside Annulus',
    col_unit: 'psi',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_summary',
    col_id: 'ECD',
    col_name: 'ECD',
    col_desc: 'Equivalent Circulating Density in the Annulus',
    col_unit: 'ppg',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_summary',
    col_id: 'pp',
    col_name: 'Pore Pressure',
    col_desc: 'Pore Pressure',
    col_unit: 'psi',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_summary',
    col_id: 'pf',
    col_name: 'Fracture Pressure',
    col_desc: 'Fracture Pressure',
    col_unit: 'psi',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_summary',
    col_id: 'ED_pp',
    col_name: 'ED Pore',
    col_desc: 'Equivalent Pore Density',
    col_unit: 'ppg',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_summary',
    col_id: 'ED_pf',
    col_name: 'ED Fracture',
    col_desc: 'Equivalent Fracture Density',
    col_unit: 'ppg',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  }
];

export default SCHEMA_SUMMARY;
